
import { ref, defineComponent, computed } from '@nuxtjs/composition-api'
import { SnapSlider } from '~/assets/ts/SnapSlider'
import IconLargeArrowRight from '~/components/icon/iconLargeArrowRight.vue'
import IconLargeArrowLeft from '~/components/icon/iconLargeArrowLeft.vue'

export default defineComponent({
  components: {
    IconLargeArrowLeft,
    IconLargeArrowRight,
  },
  props: ['nodeId', 'divide', 'sliderInterval', 'full'],
  setup(props) {
    const scrollList = (direction: number, intervalMode: boolean = false) => {
      new SnapSlider(
        document.getElementById(props.nodeId) || document.createElement('div')
      ).slide(direction)

      if (process.client && !intervalMode && sliderIntervalObj.value) {
        window.clearInterval(sliderIntervalObj.value)
        sliderIntervalObj.value = 0
      }
    }

    const sliderIntervalObj = ref(0 as number)

    const showArrows = ref(false as boolean)
    const setArrows = () => {
      showArrows.value = new SnapSlider(
        document.getElementById(props.nodeId) || document.createElement('div')
      ).hiddenItems()
    }

    const divideInput = computed(() => {
      if (props.divide === 'true') {
        return true
      } else {
        return false
      }
    })

    if (process.client) {
      setTimeout(setArrows, 200)

      window.addEventListener('resize', setArrows)
      if (
        typeof props.sliderInterval === 'string' &&
        parseInt(props.sliderInterval) > 0 &&
        sliderIntervalObj.value === 0
      ) {
        sliderIntervalObj.value = window.setInterval(() => {
          scrollList(1, true)
        }, parseInt(props.sliderInterval))
      }
    }

    return { scrollList, showArrows, divideInput }
  },
})
